import { Button, HFlow, Icon } from 'bold-ui'
import { useRouteMatch } from 'react-router'
import { useHistory, useLocation } from 'react-router-dom'
import {
  SistemaExternoIframe,
  sistemaExternoIframeStyles,
} from 'view/sistemas-externos/components/SistemaExternoIframe'

import { ProntuarioCard } from '../soap/aside/ProntuarioCard'
import { AtendimentoIframe } from './SistemasExternosAtendimentoView'

interface SistemasExternosAtendimentoDetailProps {
  atendimentoIframe: AtendimentoIframe
  url: string
  onRefresh: () => void
  loading: boolean
}

interface UrlParams {
  iframeId: string
}

interface LocationState {
  from?: string
}

export function SistemasExternosAtendimentoDetail(props: Readonly<SistemasExternosAtendimentoDetailProps>) {
  const {
    atendimentoIframe: { id, nome },
    url,
    onRefresh,
    loading,
  } = props
  const history = useHistory()
  const location = useLocation<LocationState>()
  const match = useRouteMatch<UrlParams>()

  const handleVoltar = () => {
    if (location.state?.from) {
      history.push(location.state.from)
      return
    }
    const parentUrl = match.url.replace(new RegExp(`/${id}$`), '')
    history.push(parentUrl)
  }

  const renderTitle = () => (
    <HFlow hSpacing={0.5} alignItems='center'>
      <Button skin='ghost' size='small' onClick={handleVoltar} title='Voltar'>
        <Icon icon='angleLeft' size={1.2} />
      </Button>
      {nome}
    </HFlow>
  )

  const renderContent = () => (
    <Button
      size='small'
      skin='ghost'
      style={sistemaExternoIframeStyles.reloadButton}
      onClick={onRefresh}
      disabled={loading}
    >
      <Icon icon='undo' />
    </Button>
  )

  return (
    <ProntuarioCard title={renderTitle()} content={renderContent()}>
      <SistemaExternoIframe nome={nome} url={url} />
    </ProntuarioCard>
  )
}
